import React, { useState, useEffect } from "react";
import { Label, Textarea, Switch, Dropdown, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import InfoButton from "../GenericComponent/InfoButton";
import "../CSS/ChatFlowsComponent.css";

export default function GreetingChatComponent({ chatFlowData, setChatFlowData, permissions, isEditMode, isInDiagramPanel = false }) {
  const { t } = useTranslation();
  const [greeting, setGreeting] = useState(chatFlowData?.greeting || {});

  useEffect(() => {
    if (chatFlowData?.greeting) {
      setGreeting(chatFlowData.greeting);
    }
  }, [chatFlowData]);

  const updateMessage = (messageType, field, value) => {
    const updatedGreeting = {
      ...greeting,
      [messageType]: {
        ...greeting[messageType],
        [field]: value,
      },
    };
    setGreeting(updatedGreeting);
    setChatFlowData((prev) => ({ ...prev, greeting: updatedGreeting }));
  };

  const canEdit = isEditMode
    ? permissions?.greeting?.canUpdate !== false
    : permissions?.greeting?.canCreate !== false;

  const renderMessageSection = (messageType, titleKey) => {
    const message = greeting[messageType] || {};
    
    return (
      <div className="greeting-section" key={messageType}>
        <div className="greeting-header">
          <h4>{t(titleKey)}</h4>
          <Switch
            checked={message.enabled || false}
            onChange={(_, data) => updateMessage(messageType, "enabled", data.checked)}
            disabled={!canEdit}
          />
        </div>

        {message.enabled && (
          <div className="greeting-content">
            <div>
              <Label style={{ marginBottom: "0.5rem", display: "block" }}>
                {t("MESSAGE_TEXT")}
                <InfoButton infoKey="messageText" category="CHAT_FLOWS" />
              </Label>
              <Textarea
              resize="both"
                value={message.text || ""}
                onChange={(e) => updateMessage(messageType, "text", e.target.value)}
                disabled={!canEdit}
                rows={4}
                className="chatflow-textArea-greeting"
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`greeting-container ${!isInDiagramPanel ? 'greeting-tab-view' : ''}`}>
      <h3>{t("GREETING_MESSAGES")}</h3>
      
      {renderMessageSection("welcomeMessage", "WELCOME_MESSAGE")}
      {renderMessageSection("emergencyMessage", "EMERGENCY_MESSAGE")}
      {renderMessageSection("flashMessage", "FLASH_MESSAGE")}
      {renderMessageSection("customMessage", "CUSTOM_MESSAGE")}
    </div>
  );
}
